import styled, { css } from 'styled-components';

interface IProps {
  $perView?: number;
  $offsetLR?: number;
  $colGap?: number;
  $rowGap?: number;
}

export const Prd2LineScrollBar = styled.div<IProps>`
  position: relative;
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: auto auto;
  justify-content: start;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior: contain auto;

  &::-webkit-scrollbar {
    display: none;
  }

  ${props => {
    const perView = props.$perView || 2;
    const offsetLR = props.$offsetLR || 20;
    const colGap = props.$colGap || 6;
    const rowGap = props.$rowGap || 24;

    return css`
      row-gap: ${rowGap}px;
      column-gap: ${colGap}px;
      padding: 0 ${offsetLR}px;

      &:not(.item-auto) > .item,
      &:not(.item-auto) .inner-items-scrollBar > .item {
        min-width: calc(
          ${100 / perView}vw -
            ${(2 * offsetLR + colGap * (perView - 1)) / perView}px
        );
        max-width: calc(
          ${100 / perView}vw -
            ${(2 * offsetLR + colGap * (perView - 1)) / perView}px
        );
      }
    `;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    ${props => {
      const perView = props.$perView || 2;
      const offsetLR = ((props.$offsetLR || 20) / 375) * 100;
      const colGap = ((props.$colGap || 6) / 375) * 100;
      const rowGap = ((props.$rowGap || 24) / 375) * 100;

      return css`
        row-gap: ${rowGap}vw;
        column-gap: ${colGap}vw;
        padding: 0 ${offsetLR}vw;

        &:not(.item-auto) > .item,
        &:not(.item-auto) .inner-items-scrollBar > .item {
          min-width: calc(
            ${100 / perView}vw -
              ${(2 * offsetLR + colGap * (perView - 1)) / perView}vw
          );
          max-width: calc(
            ${100 / perView}vw -
              ${(2 * offsetLR + colGap * (perView - 1)) / perView}vw
          );
        }
      `;
    }}
  }
`;
